import { Text } from "../../../../utils/constants/text";
import styled from "styled-components";

// recoil
import { useRecoilState } from "recoil";
import {
    medicalCategoryState,
    cityNameState,
    CityNameStateType,
    MedicalCategoryStateType,
} from "../../../../recoil/cityState";

// components
import MiniBox from "../../../atoms/neumorphism/miniBox";
import Glass from "../../../atoms/glass/glass";

export default function MedicalFilterBox(): JSX.Element {
    const [city, setCity] = useRecoilState(cityNameState);
    const [category, setCategory] = useRecoilState(medicalCategoryState);

    const cityArr: CityNameStateType[] = ["북구", "남구", "동구", "중구", "울주군"];
    const categoryArr: MedicalCategoryStateType[] = [
        "병원",
        "종합병원",
        "의원",
        "치과병원",
        "치과의원",
        "한방병원",
        "한의원",
        "요양병원",
        "부속의원",
        "정신병원",
    ];

    return (
        <Glass row="2">
            <MedicalFilterArea>
                {cityArr.map((a, i) => {
                    return (
                        <MiniBox
                            key={`setMedicalCityName ${i}`}
                            borderRadius="50%"
                            ratio="1/1"
                            onClick={() => {
                                setCity(a);
                            }}
                            isActive={city === a}
                        >
                            <Text.S2 style={{ whiteSpace: "nowrap" }}>{a}</Text.S2>
                        </MiniBox>
                    );
                })}
                {categoryArr.map((a, i) => {
                    return (
                        <MiniBox
                            key={`setMedicalCategoryName ${i}`}
                            onClick={() => {
                                setCategory(a);
                            }}
                            isActive={category === a}
                            ratio=""
                        >
                            <Text.S2 style={{ whiteSpace: "nowrap" }}>{a}</Text.S2>
                        </MiniBox>
                    );
                })}
            </MedicalFilterArea>
        </Glass>
    );
}

const MedicalFilterArea = styled.div`
    padding: 15px;
    height: 100%;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    gap: 10px;
`;
